/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1AccesscontrolRolesQueryResponse,
  GetApiV1AccesscontrolRoles401,
  GetApiV1AccesscontrolRoles500,
} from "../../types/accessControlUsersController/GetApiV1AccesscontrolRoles.ts";

function getGetApiV1AccesscontrolRolesUrl() {
  const res = { method: "GET", url: `/api/v1/accesscontrol/roles` as const };
  return res;
}

/**
 * @description Retorna todos os valores do enum EUserRole com id e nome. **(Requer Authorization para autenticação)**
 * @summary Buscar todos os roles (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/roles}
 */
export async function getApiV1AccesscontrolRoles(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1AccesscontrolRolesQueryResponse,
    ResponseErrorConfig<
      GetApiV1AccesscontrolRoles401 | GetApiV1AccesscontrolRoles500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1AccesscontrolRolesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
